import { IRootState } from '@/core/data/IRootState'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import { AppModule } from './modules/app'
import { AuthModule } from './modules/auth/'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence<IRootState>({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    loading: false
  },
  modules: {
    app: AppModule,
    auth: AuthModule
  },
  plugins: [vuexLocal.plugin]
})
